/* eslint-disable no-template-curly-in-string */
/* eslint-disable @typescript-eslint/camelcase */

export class MessageConverter {
  public static errorMessageConverter(errorCode: string, ..._paramArray: any[]): string {
    // エラーメッセージ一覧
    const messageMap = {
      M_ExAPI_COMMON_0044: '推奨品フォルダ情報がありません。',
      M_ExAPI_COMMON_0045: '推奨品登録権限がないため、推奨品フォルダの参照はできません。',
      M_ExAPI_COMMON_0046: '推奨品フォルダ情報の取得処理に失敗しました。もう一度お試しください。',
      M_ExAPI_COMMON_0059: '注文権限がないため、商品をカゴに追加できません。'
    };
    if (errorCode in messageMap) {
      return messageMap[errorCode];
    }
    return errorCode;
  }
}
